import { action } from "satcheljs";

const onConversationOptionSaved: () => {} = action("ON_CONVERSATION_OPTION_SAVED");
export default onConversationOptionSaved;
